<template>
  <div class="app-wrapper">
    <SideBar v-if="!sidebar.hide" ref="sideBarRef" />
    <div class="main-container">
      <Navbar />
      <div class="app-main-container">
        <AppMain />
      </div>
    </div>
  </div>
  <div class="app-background">
    <div class="bg-shape-1"></div>
    <div class="bg-shape-2"></div>
    <div class="bg-shape-3"></div>
  </div>
</template>

<script setup>
import SideBar from './components/SideBar/index.vue'
import { AppMain, Navbar } from './components'
import useUserStore from '@/store/modules/user'
import useAppStore from '@/store/modules/app'
import { computed, ref, provide } from 'vue'
import { ws_req } from '@/ws/wss-request'

const appStore = useAppStore()
const userStore = useUserStore()
const sidebar = computed(() => useAppStore().sidebar);

appStore.getStations()
appStore.getModelList()

/** 子页面（如运营工作台）可 inject 调用，与侧栏「电站切换」一致 */
const sideBarRef = ref(null)
provide('openStationSwitch', (...args) => {
  sideBarRef.value?.openStationSwitch?.(...args)
})

ws_req.connect(userStore.userId)

</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100%;
  position: relative;
  overflow: hidden;
  flex: 1;
  display: flex;
  z-index: 1;
}

.main-container {
  height: 100%;
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  z-index: 1;
  overflow: hidden;

  .app-main-container {
    height: 100%;
    flex: 1;
    overflow: hidden;
  }
}

.app-background {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  background: linear-gradient(108.83deg, #E5F6FF 0.85%, #F8F8F8 49.22%, #F1FFFC 99.49%);

  .bg-shape-1 {
    position: absolute;
    width: 736px;
    height: 736px;
    left: -183px;
    top: 530px;

    background: #F9E4E0;
    filter: blur(250px);

  }

  .bg-shape-2 {
    position: absolute;
    width: 1023px;
    height: 1023px;
    left: 1038px;
    top: -175px;

    background: #E2F1FF;
    filter: blur(250px);
  }

  .bg-shape-3 {
    position: absolute;
    width: 745px;
    height: 745px;
    left: 1240px;
    top: 574px;

    background: #DCDCFF;
    filter: blur(250px);

  }
}

.app-versions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-top: 1px solid blue;
}
</style>
